import {createAction as createActionCreator} from 'redux-actions';
import {Map, fromJS} from 'immutable';
import axios from 'axios';
import * as uuid from 'uuid';
import {push} from 'react-router-redux';

import {getParentDataAsPOJO} from './components/parent/parent';
import {getChildrenDataAsPOJO} from './components/child/child';
import * as constants from './constants';
import {reset as resetChildData} from './components/child/child'
import {reset as resetParentData} from './components/parent/parent'
import {TIMEOUT_XML_HTTP_REQUESTS_MILLIS} from "./constants";

const NAMESPACE = `${constants.NAMESPACE}/main`;

// Actions
const REQUEST_STARTED = `${NAMESPACE}/REQUEST_STARTED`;
const REQUEST_COMPLETED = `${NAMESPACE}/REQUEST_COMPLETED`;
const REQUEST_FAILED = `${NAMESPACE}/REQUEST_FAILED`;
const RESET_TRANSMISSION_STATUS = `${NAMESPACE}/RESET_FAULT`;
const SAVE_SETTINGS = `${NAMESPACE}/SAVE_SETTINGS`;
const VIEWPORT_WIDTH_CHANGED = `${NAMESPACE}/VIEWPORT_WIDTH_CHANGED`;

// State
export const STATE_IS_TRANSMITTING = 'isTransmitting';
export const STATE_TRANSMISSION_RESULT = 'result';
export const STATE_TRANSMISSION_STATUS = 'transmissionStatus';
export const STATE_UUID = 'uuid';
export const STATE_INTERNAL_USE = 'internalUse';
export const STATE_VIEWPORT_WIDTH = 'viewportWidth';

// Reducer
export default function reducer(state = defaultState(), action = {}) {
  // Make sure rehidrated state gets converted to immutable
  if (!Map.isMap(state)) {
    console.warn(`state is no Map but ${typeof state} -> converting to Map NOW.`);
    state = fromJS(state);
  }

  switch (action.type) {
    case REQUEST_STARTED:
      return state.withMutations(map => {
        map.set(STATE_IS_TRANSMITTING, true)
          .set(STATE_TRANSMISSION_STATUS, 'transmitting')
      });
    case REQUEST_COMPLETED:
      return state.withMutations(map => {
        map.set(STATE_IS_TRANSMITTING, false)
          .set(STATE_TRANSMISSION_STATUS, 'success')
          .set(STATE_TRANSMISSION_RESULT, action.payload);
      });
    case REQUEST_FAILED:
      return state.withMutations(map => {
        map.set(STATE_IS_TRANSMITTING, false)
          .set(STATE_TRANSMISSION_STATUS, 'error')
          .set(STATE_TRANSMISSION_RESULT, action.payload);
      });
    case RESET_TRANSMISSION_STATUS:
      return state.set(STATE_TRANSMISSION_STATUS, 'initial');
    case SAVE_SETTINGS:
      return state.set(STATE_INTERNAL_USE, action.payload);
    case VIEWPORT_WIDTH_CHANGED:
      return state.set(STATE_VIEWPORT_WIDTH, action.payload);
    default:
      return state;
  }
}

function defaultState() {
  return Map({
    [STATE_IS_TRANSMITTING]: false,
    [STATE_TRANSMISSION_STATUS]: 'initial',
    [STATE_TRANSMISSION_RESULT]: {},
    [STATE_UUID]: uuid.v4(),
    [STATE_INTERNAL_USE]: false,
  })
}

// Action Creators
const createRequestStartedActionCreator = createActionCreator(REQUEST_STARTED);
function requestStarted() {
  return createRequestStartedActionCreator();
}

const createRequestCompletedActionCreator = createActionCreator(REQUEST_COMPLETED);
function requestCompleted(result) {
  return createRequestCompletedActionCreator(result);
}

const createRequestFailedActionCreator = createActionCreator(REQUEST_FAILED);
function requestFailed(result) {
  return createRequestFailedActionCreator(result);
}

const createResetTransmissionStatusActionCreator = createActionCreator(RESET_TRANSMISSION_STATUS);
function resetTransmissionStatus() {
  return createResetTransmissionStatusActionCreator();
}

const createSaveSettingsActionCreator = createActionCreator(SAVE_SETTINGS);
export function saveSettings(internalUse) {
  return createSaveSettingsActionCreator(internalUse);
}

const createViewportWidthChangedActionCreator = createActionCreator(VIEWPORT_WIDTH_CHANGED);
export function viewportWidthChanged(viewportWidth) {
  return createViewportWidthChangedActionCreator(viewportWidth);
}

export function getIsTransmitting(state) {
  return state.get(STATE_IS_TRANSMITTING);
}

export function getTransmissionStatus(state) {
  return state.get(STATE_TRANSMISSION_STATUS);
}

export function getTransmissionResult(state) {
  return state.get(STATE_TRANSMISSION_RESULT);
}

export function getIsInternalUse(state) {
  return state.get(STATE_INTERNAL_USE);
}

export function sendAnmeldungRequest() {
  return function (dispatch, getState) {
    dispatch(requestStarted());

    let state = getState();
    let data = getParentDataAsPOJO(state.parent);
    data.kinder = getChildrenDataAsPOJO(state.children);
    data.uuid = state.main.get('uuid');

    axios.request({
      url: '/api/anmeldung',
      method: 'post',
      data: JSON.stringify(data),
      timeout: TIMEOUT_XML_HTTP_REQUESTS_MILLIS,
      responseType: 'json',
    })
      .then(function (response) {
        if (response.data.result === 'ok') {
          dispatch(requestCompleted(response));
          dispatch(resetChildData());
          dispatch(resetParentData());
          dispatch(push('/fast-fertig'));
          dispatch(resetTransmissionStatus());
        } else {
          dispatch(requestFailed(response.data.error))
        }
      })
      .catch(function (error) {
        dispatch(requestFailed(error));
        setTimeout(() => dispatch(resetTransmissionStatus()), 3000);
      });
  }
}

export function sendAnmeldungBestaetigenRequest(uuid) {
  return function (dispatch) {
    dispatch(requestStarted());

    axios.request({
      url: '/api/anmeldung',
      method: 'put',
      data: JSON.stringify({uuid: uuid}),
      timeout: TIMEOUT_XML_HTTP_REQUESTS_MILLIS,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json; charset=utf8',
        'Accept': 'application/json',
      },
    })
      .then(function (response) {
        if (response.data.result === 'ok') {
          dispatch(requestCompleted(response));
        } else {
          dispatch(requestFailed(response.data.error))
        }
      })
      .catch(function (error) {
        dispatch(requestFailed(error));
      });
  }
}



// WEBPACK FOOTER //
// ./src/main.js